import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IMandatoryFieldConfiguration, mandatoryFieldConfigurationsManager } from '@inpart-io/padme-iap';

import { store } from '../index';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IMandatoryFieldConfigurationByClassName, type IMandatoryFieldContainerState } from './types';

const MANDATORY_FIELD_CONFIGURATION_MODULE = 'mandatoryFieldConfiguration';

const state: IMandatoryFieldConfigurationByClassName & IMandatoryFieldContainerState = {
    mandatoryFieldConfigurationByClassName: new Map(),
    timestamp: null,
    complete: true
};

const dataObjectModule = getDataObjectsModule<IMandatoryFieldConfiguration>(mandatoryFieldConfigurationsManager, 5);

const MandatoryFieldConfigurationModuleInstance = merge<unknown>(dataObjectModule, { state, actions, getters, mutations });
store.registerModule(MANDATORY_FIELD_CONFIGURATION_MODULE, MandatoryFieldConfigurationModuleInstance);

export { MANDATORY_FIELD_CONFIGURATION_MODULE };
